import { StoreModule } from '@ngrx/store';
// NgRx reducers
import { getLogger } from 'NewAngular/state/logger';
// Module imports
import { BaseSecurityPageModule } from 'SecuritiesApp/ts/apps/base-security-page/app.module';
import { HoldingsOverlapComponent } from 'SecuritiesApp/ts/features/holdings-overlap/holdings-overlap.component';
// Components
import { HoldingsOverlapModule } from 'SecuritiesApp/ts/features/holdings-overlap/holdings-overlap.module';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'NewAngular/features/components/side-menu/side-menu.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class CompanyFundsHoldingsOverlapModule {
}
CompanyFundsHoldingsOverlapModule.ɵfac = function CompanyFundsHoldingsOverlapModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CompanyFundsHoldingsOverlapModule)(); };
CompanyFundsHoldingsOverlapModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CompanyFundsHoldingsOverlapModule, bootstrap: [TopBarNavComponent, SideMenuComponent, SecurityHeaderControlComponent, HoldingsOverlapComponent] });
CompanyFundsHoldingsOverlapModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseSecurityPageModule, HoldingsOverlapModule, StoreModule.forRoot({}, { metaReducers: getLogger() })] });
